import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const IndemnitySettingService = {
  async getIndemnitySettings() {
    try {
      const result = await axios.get(`${apiUrl}/MissionIndemnity/indemnitySettings`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return { status: false, message: error.message };
    }
  },

  async saveIndemnitySetting(payload) {
    try {
        const result = await axios.post(`${apiUrl}/MissionIndemnity/saveIndemnitySetting`, payload);
        if (result) {
          return result.data;
        }
      
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return { status: false, message: error.message };
    }
  },

  async deleteIndemnitySetting(indemnity_id) {
    try {
      const result = await axios.delete(`${apiUrl}/MissionIndemnity/indemnitySetting/${indemnity_id}`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return { status: false, message: error.message };
    }
  },
    async listetrame(page = 1, limit = 20, reference = '') {
      try {
        const params = {
          page: page,
          limit: limit
        };
        
        if (reference && reference.trim() !== '') {
          params.reference = reference;
        }
        
        const result = await axios.get(`${apiUrl}/Trame`, { params });
        
        if (result && result.data) {
          return result.data;
        }
        return { status: false, message: 'Aucune donnée reçue' };
      } catch (error) {
        console.error('Erreur API:', error);
        if (error.response) {
          return error.response.data;
        }
        return { status: false, message: error.message };
      }
    },
   async IndemnityDetail(id,timesheetid) {
    try {
      const result = await axios.get(`${apiUrl}/IndemnityPDF/detailindemnity/`+id+'/'+timesheetid);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return { status: false, message: error.message };
    }
  },
  async Activeindemnity() {
    try {
      const result = await axios.get(`${apiUrl}/IndemnityPDF/activeindeminty`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return { status: false, message: error.message };
    }
  },
  async hisrtoryindemnity(payload,id,timesheet_id) {
    try {
      const result = await axios.post(`${apiUrl}/IndemnityPDF/history`,{
        payload:payload,
        id:id,
        timesheetid:timesheet_id
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return { status: false, message: error.message };
    }
  },
  async detailinvalidate(id,timesheetid) {
    try {
      const result = await axios.get(`${apiUrl}/IndemnityPDF/detailvalidation/`+id+'/'+timesheetid);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return { status: false, message: error.message };
    }
  },

  async refusedvalidate(reason,missionplanningid,timesheetid) {
    try {
      const result = await axios.post(`${apiUrl}/IndemnityPDF/refusevalidate`,{
        "missionplanningid":missionplanningid,
        "reason":reason,
        "timesheetid":timesheetid
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return { status: false, message: error.message };
    }
  },
   async validateindemnity(missionplanningid,timesheet_id) {
    try {
      const result = await axios.get(`${apiUrl}/IndemnityPDF/validateindemnity/`+missionplanningid+'/'+timesheet_id);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return { status: false, message: error.message };
    }
  }

};

export default IndemnitySettingService;

